// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* "View details" for an agent. Geometry mirrors the dataset detail modal so the
   two read as one family; colours come from ../../../styles/curioTokens.css. */

/* The Data Catalog's details header, matched: icon and title on the left, the
 * action on the right, one rule apart. The three details views were three
 * different headers - this one stacked an icon and a title with the action
 * pushed down into the body, while Data put the action on the header row - so
 * the same screen looked like a different product in each catalog. */
.K2KWUt_NgLXcGex1wamo {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
    /* Right padding clears ModalShell's own close button, which is absolutely
       positioned in the top-right corner. Without it the header's action landed
       underneath the X. */
    padding: 24px 68px 16px 28px;
    border-bottom: 1px solid var(--curio-border);
}

/* The icon + title pair, so the action can be the header's other child. */
.v_a_K9PC6YwgCihER8Tu {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    min-width: 0;
}

.eabhW1kO7C9LsAt5rrmB {
    margin: 0 0 6px;
    /* 22px/700, the Data panel's heading size. This was 20px/600. */
    font-size: 22px;
    font-weight: 700;
    line-height: 1.2;
    color: var(--curio-text-primary);
}

.rwuiKr6qDNA_hHEuGC1E {
    margin: 2px 0 0;
    font-size: 13px;
    color: var(--curio-text-secondary);
}

.Fpi3qCXKxcC6kVe5srlU {
    padding: 20px 28px 28px;
    overflow-y: auto;
}

.ekewsJ_XnmVjviidrdoi {
    margin: 0 0 20px;
    font-size: 14px;
    line-height: 1.5;
    color: var(--curio-text-primary);
}

.YLf7K3wc26_ksfVNBlbZ {
    margin-bottom: 20px;
}

.RI6v5v0ovhqHhwRoN1RA {
    margin: 0 0 8px;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.7px;
    text-transform: uppercase;
    color: var(--curio-text-muted);
}

.xlSVyYdptPCtbTefPZ36 {
    display: grid;
    grid-template-columns: minmax(120px, max-content) 1fr;
    gap: 6px 20px;
    margin: 0;
    font-size: 13px;
}

.q971OV79FU0fJZqVZAoQ {
    margin: 0;
    color: var(--curio-text-secondary);
}

.OzCVE_wldVM7cMSF2J0R {
    margin: 0;
    color: var(--curio-text-primary);
    /* Identifiers and version strings have no spaces to break at. */
    overflow-wrap: anywhere;
}

.ODagQwSKbnmlKWt38YUC {
    margin: 0;
    padding-left: 18px;
    font-size: 13px;
    line-height: 1.6;
    color: var(--curio-text-primary);
}

/* A section's one paragraph, such as what an agent does in chat: the purpose's
   type, with the section keeping the spacing. */
.Q0HBw7Eu5MmXpCjvBTc4 {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
    color: var(--curio-text-primary);
}

/* The capability ids under a mode, for developers: the prompts' type. */
.eddpE3An9ct5tfXbrNHu {
    font-family: var(--curio-font-mono, ui-monospace, monospace);
    font-size: 11px;
    line-height: 1.5;
    color: var(--curio-text-secondary);
    overflow-wrap: anywhere;
}

/* ── Export, and the prompts it exports ──────────────────────────────────── */

.RW_pLzmLQBZRJKlueQbx {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

/* The action fill, the same as every other action in the catalogs. */
.yenHhji5UoO6IZzTLlIN {
  min-height: 34px;
  border: 0;
  border-radius: 7px;
  padding: 0 14px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
  background: var(--curio-top-bar-bg);
  color: var(--curio-text-on-dark);
  cursor: pointer;
}

.yenHhji5UoO6IZzTLlIN:hover:not(:disabled) {
  background: var(--curio-top-bar-bg-hover);
}

.yenHhji5UoO6IZzTLlIN:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.Mg5jWwu7d0t4HJCcUvL9 {
  border: 1px solid var(--curio-border);
  border-radius: 8px;
  background: var(--curio-card-bg);
  margin-bottom: 8px;
}

.V_rWYYA1AadbXVbV9SBu {
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  font-family: var(--curio-font-mono, ui-monospace, monospace);
  color: var(--curio-text-primary);
  cursor: pointer;
}

/* When the prompt runs, in plain words before its file name. */
.K8n5Z8rYIpIetS2EOBvh {
  font-family: var(--curio-font-family);
}

/* Prompts are long and contain their own hard wrapping, so preserve it and let
 * the block scroll rather than stretching the modal. */
.AMfJepLDijwN5cTZmGEg {
  margin: 0;
  padding: 0 12px 12px;
  max-height: 320px;
  overflow: auto;
  font-family: var(--curio-font-mono, ui-monospace, monospace);
  font-size: 11px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
  color: var(--curio-text-secondary);
}

/* "Change in API Settings" beside the Model row: a link in look, a button in
   behaviour (it opens a modal rather than navigating). */
.pz3nAFMyo5p9x3Jqr14V {
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  color: var(--curio-role-published-fg);
  text-decoration: underline;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/agents/catalog/AgentDetailModal.module.css"],"names":[],"mappings":"AAAA;+EAC+E;;AAE/E;;;;qEAIqE;AACrE;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT;;0BAEsB;IACtB,4BAA4B;IAC5B,4CAA4C;AAChD;;AAEA,0EAA0E;AAC1E;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gEAAgE;IAChE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,qDAAqD;IACrD,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,kCAAkC;AACtC;;AAEA;IACI,SAAS;IACT,gCAAgC;IAChC,gEAAgE;IAChE,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;gDACgD;AAChD;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA,wEAAwE;AACxE;IACI,4DAA4D;IAC5D,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA,qEAAqE;AACrE;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,4DAA4D;EAC5D,gCAAgC;EAChC,eAAe;AACjB;;AAEA,+DAA+D;AAC/D;EACE,qCAAqC;AACvC;;AAEA;uDACuD;AACvD;EACE,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;yDACyD;AACzD;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,0BAA0B;EAC1B,eAAe;AACjB","sourcesContent":["/* \"View details\" for an agent. Geometry mirrors the dataset detail modal so the\n   two read as one family; colours come from ../../../styles/curioTokens.css. */\n\n/* The Data Catalog's details header, matched: icon and title on the left, the\n * action on the right, one rule apart. The three details views were three\n * different headers - this one stacked an icon and a title with the action\n * pushed down into the body, while Data put the action on the header row - so\n * the same screen looked like a different product in each catalog. */\n.header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 20px;\n    /* Right padding clears ModalShell's own close button, which is absolutely\n       positioned in the top-right corner. Without it the header's action landed\n       underneath the X. */\n    padding: 24px 68px 16px 28px;\n    border-bottom: 1px solid var(--curio-border);\n}\n\n/* The icon + title pair, so the action can be the header's other child. */\n.titleBlock {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n    min-width: 0;\n}\n\n.title {\n    margin: 0 0 6px;\n    /* 22px/700, the Data panel's heading size. This was 20px/600. */\n    font-size: 22px;\n    font-weight: 700;\n    line-height: 1.2;\n    color: var(--curio-text-primary);\n}\n\n.subtitle {\n    margin: 2px 0 0;\n    font-size: 13px;\n    color: var(--curio-text-secondary);\n}\n\n.body {\n    padding: 20px 28px 28px;\n    overflow-y: auto;\n}\n\n.purpose {\n    margin: 0 0 20px;\n    font-size: 14px;\n    line-height: 1.5;\n    color: var(--curio-text-primary);\n}\n\n.section {\n    margin-bottom: 20px;\n}\n\n.sectionLabel {\n    margin: 0 0 8px;\n    font-size: 10px;\n    font-weight: 600;\n    letter-spacing: 0.7px;\n    text-transform: uppercase;\n    color: var(--curio-text-muted);\n}\n\n.infoGrid {\n    display: grid;\n    grid-template-columns: minmax(120px, max-content) 1fr;\n    gap: 6px 20px;\n    margin: 0;\n    font-size: 13px;\n}\n\n.infoLabel {\n    margin: 0;\n    color: var(--curio-text-secondary);\n}\n\n.infoValue {\n    margin: 0;\n    color: var(--curio-text-primary);\n    /* Identifiers and version strings have no spaces to break at. */\n    overflow-wrap: anywhere;\n}\n\n.list {\n    margin: 0;\n    padding-left: 18px;\n    font-size: 13px;\n    line-height: 1.6;\n    color: var(--curio-text-primary);\n}\n\n/* A section's one paragraph, such as what an agent does in chat: the purpose's\n   type, with the section keeping the spacing. */\n.sectionText {\n    margin: 0;\n    font-size: 14px;\n    line-height: 1.5;\n    color: var(--curio-text-primary);\n}\n\n/* The capability ids under a mode, for developers: the prompts' type. */\n.modeIds {\n    font-family: var(--curio-font-mono, ui-monospace, monospace);\n    font-size: 11px;\n    line-height: 1.5;\n    color: var(--curio-text-secondary);\n    overflow-wrap: anywhere;\n}\n\n/* ── Export, and the prompts it exports ──────────────────────────────────── */\n\n.actions {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n/* The action fill, the same as every other action in the catalogs. */\n.exportButton {\n  min-height: 34px;\n  border: 0;\n  border-radius: 7px;\n  padding: 0 14px;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 700;\n  background: var(--curio-top-bar-bg);\n  color: var(--curio-text-on-dark);\n  cursor: pointer;\n}\n\n.exportButton:hover:not(:disabled) {\n  background: var(--curio-top-bar-bg-hover);\n}\n\n.exportButton:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.promptBlock {\n  border: 1px solid var(--curio-border);\n  border-radius: 8px;\n  background: var(--curio-card-bg);\n  margin-bottom: 8px;\n}\n\n.promptName {\n  padding: 8px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: var(--curio-font-mono, ui-monospace, monospace);\n  color: var(--curio-text-primary);\n  cursor: pointer;\n}\n\n/* When the prompt runs, in plain words before its file name. */\n.promptRuns {\n  font-family: var(--curio-font-family);\n}\n\n/* Prompts are long and contain their own hard wrapping, so preserve it and let\n * the block scroll rather than stretching the modal. */\n.promptText {\n  margin: 0;\n  padding: 0 12px 12px;\n  max-height: 320px;\n  overflow: auto;\n  font-family: var(--curio-font-mono, ui-monospace, monospace);\n  font-size: 11px;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n  color: var(--curio-text-secondary);\n}\n\n/* \"Change in API Settings\" beside the Model row: a link in look, a button in\n   behaviour (it opens a modal rather than navigating). */\n.inlineLink {\n  padding: 0;\n  border: none;\n  background: none;\n  font: inherit;\n  color: var(--curio-role-published-fg);\n  text-decoration: underline;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `K2KWUt_NgLXcGex1wamo`,
	"titleBlock": `v_a_K9PC6YwgCihER8Tu`,
	"title": `eabhW1kO7C9LsAt5rrmB`,
	"subtitle": `rwuiKr6qDNA_hHEuGC1E`,
	"body": `Fpi3qCXKxcC6kVe5srlU`,
	"purpose": `ekewsJ_XnmVjviidrdoi`,
	"section": `YLf7K3wc26_ksfVNBlbZ`,
	"sectionLabel": `RI6v5v0ovhqHhwRoN1RA`,
	"infoGrid": `xlSVyYdptPCtbTefPZ36`,
	"infoLabel": `q971OV79FU0fJZqVZAoQ`,
	"infoValue": `OzCVE_wldVM7cMSF2J0R`,
	"list": `ODagQwSKbnmlKWt38YUC`,
	"sectionText": `Q0HBw7Eu5MmXpCjvBTc4`,
	"modeIds": `eddpE3An9ct5tfXbrNHu`,
	"actions": `RW_pLzmLQBZRJKlueQbx`,
	"exportButton": `yenHhji5UoO6IZzTLlIN`,
	"promptBlock": `Mg5jWwu7d0t4HJCcUvL9`,
	"promptName": `V_rWYYA1AadbXVbV9SBu`,
	"promptRuns": `K8n5Z8rYIpIetS2EOBvh`,
	"promptText": `AMfJepLDijwN5cTZmGEg`,
	"inlineLink": `pz3nAFMyo5p9x3Jqr14V`
};
export default ___CSS_LOADER_EXPORT___;
